/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import {
    cityList,
    stateCityCheck,
    stateList,
    zipCodeDetails,
} from '../settings/apiconfig';
import interfaceService from './interfaceService';
import { getBuyerHeaders, getBuyersUrl } from 'shared/http';


class CityAndStateService {
    constructor() {
        this.service = interfaceService.getService();
    }

    getZipCodeDeatils(zipcode) {
        return this.service.get(getBuyersUrl(`${zipCodeDetails}/${zipcode}`), getBuyerHeaders());
    }

    getStateList() {
        return this.service.get(getBuyersUrl(stateList), getBuyerHeaders());
    }

    getCityList(stateName) {
        return this.service.get(getBuyersUrl(`${cityList}${stateName}`), getBuyerHeaders());
    }

    checkCityState(data) {
        return this.service.post(getBuyersUrl(stateCityCheck), JSON.stringify(data), getBuyerHeaders());
    }
}

export default new CityAndStateService();